import '@accessible360/accessible-slick';

export const PostSlider = (() => {
	'use strict';

	let $postSlider;

	function init() {
		$postSlider = $('.post-slider');

        if (!$postSlider.length) {
            return;
        }

		$postSlider.slick({
			infinite: false,
			dots: false,
			arrows: false,
			slidesToShow: 1,
			cssEase: 'ease-in-out',
			autoplay: false,
			focusOnSelect: true,
			slidesToScroll: 2,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToScroll: 1,
						variableWidth: false,
						margin: 20,
					}
				},
				{
					breakpoint: 1280,
					settings: {
						slidesToScroll: 1,
					}
				}
			]
		});
	}

	return {
		init: init,
		name: 'slideshow'
	};
})();
